module.exports = __webpack_public_path__ + "static/media/traffic-severe.842f603e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nxbus/traffic-severe.svg
// module id = 788
// module chunks = 0